<template>
  <div :class="$style.propertySection" data-testid="my-properties-skeleton">
    <div :class="$style.valueWrapper">
      <div v-for="item in 4" :key="item" :class="$style.valueItemWrapper">
        <HgSkeleton height="22px" width="80px" :class="$style.withRoundedLarge" />
      </div>
    </div>
    <HgSkeleton height="28px" width="150px" />
    <div :class="$style.valueWrapper">
      <div v-for="item in 3" :key="item" :class="$style.valueItemWrapper">
        <HgSkeleton height="22px" width="32px" />
        <HgSkeleton height="14px" width="65px" />
      </div>
    </div>
    <div :class="$style.propertyGroup">
      <HgCardFlat v-for="item in propertyGroupSize" :key="item" :class="$style.cardContainer">
        <HgSkeleton height="153px" />
        <div :class="$style.tileContentWrapper">
          <HgSkeleton height="18px" />
          <HgSkeleton height="14px" width="60%" />
          <div :class="$style.blockWrapper">
            <div v-for="item in 3" :key="item" :class="$style.withSplitter">
              <HgSkeleton height="14px" width="48px" />
            </div>
          </div>
          <div :class="$style.blockWrapper">
            <HgSkeleton height="18px" width="65%" />
            <HgSkeleton height="18px" width="18px" :class="$style.withRounded" />
          </div>
          <div :class="$style.tileContentFooterWrapper">
            <HgSkeleton height="15px" width="80px" :class="$style.withRounded" />
          </div>
        </div>
      </HgCardFlat>
    </div>
    <HgSkeleton height="21px" width="74px" :class="[$style.showAll, $style.withRounded]" />
  </div>
</template>

<script setup lang="ts">
import { useMedia } from '@/composables/useMedia';
import { HgCardFlat, HgSkeleton } from '@smg-real-estate/domus';
import { computed } from 'vue';

const { isSmallScreen, isLargeScreen } = useMedia();

const propertyGroupSize = computed<number>(() => {
  // default: shows 3 tiles, on tablet: shows 2 tiles
  return isSmallScreen.value === false && isLargeScreen.value === false ? 2 : 3;
});
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.propertySection {
  display: flex;
  flex-direction: column;
  gap: $space-150;
}

.propertyGroup {
  display: grid;
  grid-template-columns: 1fr;
  gap: calc($space-150 - $space-25);

  @include grid-media-query(sm) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include grid-media-query(md) {
    grid-template-columns: repeat(3, 1fr);
  }
}
.cardContainer[class*='HgCardFlat_cardFlat'] {
  border-color: $color-grey-60;
}

.tileContentWrapper {
  display: flex;
  flex-direction: column;
  padding: $space-75;
  gap: $space-50;
}

.tileContentFooterWrapper {
  padding-top: $space-75;
  border-top: 1px solid $color-grey-60;
}

.blockWrapper {
  display: flex;
  gap: $space-50;
  @include vertical-margin($space-25, $space-25);
}

.withSplitter:not(:first-child) {
  margin-right: 1px;
  &:before {
    content: '';
    width: 1px;
    height: 14px;
    background-color: $color-grey-60;
    position: absolute;
    margin-left: calc($space-25 * -1 - 1px);
  }
}

.withRounded {
  border-radius: $border-radius;
}

.withRoundedLarge {
  border-radius: calc($border-radius-xl + 2px);
}

.showAll {
  @include vertical-margin(-$space-50);
}

.valueItemWrapper {
  display: flex;
  flex-direction: column;
  gap: $space-50;
}

.valueWrapper {
  display: flex;
  gap: $space-100;
  overflow-x: auto;
  scrollbar-width: none;
}
</style>
